"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDownloadFile = void 0;
var react_1 = require("react");
var useDownloadFile = function () {
    return (0, react_1.useCallback)(function (file) {
        var url = window.URL.createObjectURL(new Blob([file]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file.name);
        document.body.appendChild(link);
        // Start download
        link.click();
        document.body.removeChild(link);
    }, []);
};
exports.useDownloadFile = useDownloadFile;
